import React from 'react';
import { Bookmark } from '@mui/icons-material';
import finger1 from "../img/finger/finger1.png";
import finger2 from "../img/finger/finger2.png";
import finger3 from "../img/finger/finger3.png";

import hand1 from "../img/fingerdont/hand1.png"
import hand2 from "../img/fingerdont/hand2.png"
import hand3 from "../img/fingerdont/hand3.png"
import hand4 from "../img/fingerdont/hand4.png"
import hand5 from "../img/fingerdont/hand5.png"

import hand6 from "../img/fingerdont/hand6.png"
import hand7 from "../img/fingerdont/hand7.png"
import hand8 from "../img/fingerdont/hand8.png"
import hand9 from "../img/fingerdont/hand9.png"
import hand10 from "../img/fingerdont/hand10.png"

import hand11 from "../img/fingerdont/hand11.png"
import hand12 from "../img/fingerdont/hand12.png"
import hand13 from "../img/fingerdont/hand13.png"
import hand14 from "../img/fingerdont/hand14.png"
import hand15 from "../img/fingerdont/hand15.png"

const Hands = ({ onImageClick }) => {
  return (
    <>
      <div className="help-center__examples help-center__examples--first">
        <div className="help-center__examples-header">
          <Bookmark />
          <h3 className="help-center__examples-title">Holding the smartphone</h3>
        </div>
        
        <div className="help-center__example-card">
          <div className="help-center__example-images">
            <div className="help-center__image-placeholder help-center__image-placeholder--do">
              <div className="help-center__image-label">Do</div>
              <div className="help-center__image-box">
                <img src={finger1} alt="" onClick={() => onImageClick && onImageClick(finger1)} style={{cursor: 'pointer'}} />
              </div>
              <p className="help-center__image-caption">4 fingers visible</p>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
                <img src={finger2} alt="" onClick={() => onImageClick && onImageClick(finger2)} style={{cursor: 'pointer'}} />
              </div>
              <p className="help-center__image-caption">5 fingers showing</p>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
                <img src={finger3} alt="" onClick={() => onImageClick && onImageClick(finger3)} style={{cursor: 'pointer'}} />
              </div>
              <p className="help-center__image-caption">Too many fingers</p>
            </div>
          </div>
        </div>
      </div>


  
      
      <div className="help-center__examples">
        <div className="help-center__examples-header">
          <Bookmark />
          <h3 className="help-center__examples-title">Common hands mistakes to avoid</h3>
        </div>
        
        <div className="help-center__example-card">
          <div className="help-center__grid-images">
            <div className="help-center__grid-item help-center__image-placeholder--dont">
              <div className="help-center__image-box">
                <img src={hand1} alt="" onClick={() => onImageClick && onImageClick(hand1)} style={{cursor: 'pointer'}} />
              </div>
            </div>
            <div className="help-center__grid-item help-center__image-placeholder--dont">
              <div className="help-center__image-box">
                <img src={hand2} alt="" onClick={() => onImageClick && onImageClick(hand2)} style={{cursor: 'pointer'}} />
              </div>
            </div>
            <div className="help-center__grid-item help-center__image-placeholder--dont">
              <div className="help-center__image-box">
                <img src={hand3} alt="" onClick={() => onImageClick && onImageClick(hand3)} style={{cursor: 'pointer'}} />
              </div>
            </div>
            <div className="help-center__grid-item help-center__image-placeholder--dont">
              <div className="help-center__image-box">
                <img src={hand4} alt="" onClick={() => onImageClick && onImageClick(hand4)} style={{cursor: 'pointer'}} />
              </div>
            </div>
            <div className="help-center__grid-item help-center__image-placeholder--dont">
              <div className="help-center__image-box">
                <img src={hand5} alt="" onClick={() => onImageClick && onImageClick(hand5)} style={{cursor: 'pointer'}} />
              </div>
            </div>
            <div className="help-center__grid-item help-center__image-placeholder--dont">
              <div className="help-center__image-box">
                <img src={hand6} alt="" onClick={() => onImageClick && onImageClick(hand6)} style={{cursor: 'pointer'}} />
              </div>
            </div>
            <div className="help-center__grid-item help-center__image-placeholder--dont">
              <div className="help-center__image-box">
                <img src={hand7} alt="" onClick={() => onImageClick && onImageClick(hand7)} style={{cursor: 'pointer'}} />
              </div>
            </div>
            <div className="help-center__grid-item help-center__image-placeholder--dont">
              <div className="help-center__image-box">
                <img src={hand8} alt="" onClick={() => onImageClick && onImageClick(hand8)} style={{cursor: 'pointer'}} />
              </div>
            </div>
            <div className="help-center__grid-item help-center__image-placeholder--dont">
              <div className="help-center__image-box">
                <img src={hand9} alt="" onClick={() => onImageClick && onImageClick(hand9)} style={{cursor: 'pointer'}} />
              </div>
            </div>
            <div className="help-center__grid-item help-center__image-placeholder--dont">
              <div className="help-center__image-box">
                <img src={hand10} alt="" onClick={() => onImageClick && onImageClick(hand10)} style={{cursor: 'pointer'}} />
              </div>
            </div>
            <div className="help-center__grid-item help-center__image-placeholder--dont">
              <div className="help-center__image-box">
                <img src={hand11} alt="" onClick={() => onImageClick && onImageClick(hand11)} style={{cursor: 'pointer'}} />
              </div>
            </div>
            <div className="help-center__grid-item help-center__image-placeholder--dont">
              <div className="help-center__image-box">
                <img src={hand12} alt="" onClick={() => onImageClick && onImageClick(hand12)} style={{cursor: 'pointer'}} />
              </div>
            </div>
            <div className="help-center__grid-item help-center__image-placeholder--dont">
              <div className="help-center__image-box">
                <img src={hand13} alt="" onClick={() => onImageClick && onImageClick(hand13)} style={{cursor: 'pointer'}} />
              </div>
            </div>
            <div className="help-center__grid-item help-center__image-placeholder--dont">
              <div className="help-center__image-box">
                <img src={hand14} alt="" onClick={() => onImageClick && onImageClick(hand14)} style={{cursor: 'pointer'}} />
              </div>
            </div>
            <div className="help-center__grid-item help-center__image-placeholder--dont">
              <div className="help-center__image-box">
                <img src={hand15} alt="" onClick={() => onImageClick && onImageClick(hand15)} style={{cursor: 'pointer'}} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Hands;